// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.gray {
  color: gray;
}

.silver {
  color: #C3CDE6;
}

.gold {
  color: gold;
}

.brown {
  color: brown;
}

.fbox {
  flex: 1;
  display: flex;
}

.vflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: column;
  flex-direction: column;
}

.hflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

.shadow-gray {
  border: 1px solid lightgray;
  box-shadow: 2px 2px 5px 1px lightgray;
}

.space-between {
  /* previous syntax */
  -ms-box-pack: justify;
  box-pack: justify;
  /* current syntax */
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}

.flex-left {
  justify-self: flex-start;
  margin-right: auto;
}

.flex-right {
  justify-self: flex-end;
  margin-left: auto;
}

.right-margin-20 {
  margin-right: 20px;
}

.left-margin-20 {
  margin-left: 20px;
}

.bottom-margin-20 {
  margin-bottom: 20px;
}

.bottom-margin-30 {
  margin-bottom: 30px;
}

.bottom-margin-40 {
  margin-bottom: 40px;
}

.top-margin-20 {
  margin-top: 20px;
}

.top-margin-40 {
  margin-top: 40px;
}

.margin-auto {
  margin: auto;
}

.h-margin-auto {
  margin-right: auto;
  margin-left: auto;
}

.v-margin-auto {
  margin-top: auto;
  margin-bottom: auto;
}

.flex-30 {
  flex: 0 0 30%;
}

.flex-90 {
  flex: 0 0 90%;
}

.padding-right-10 {
  padding-right: 10%;
}

.main {
  /* previous syntax */
  -ms-box-flex: 1;
  box-flex: 1;
  /* current syntax */
  -moz-flex: 1;
  flex: 1;
  height: 100%;
  width: 100%;
  margin: 0;
  overflow-y: auto;
}

.main-header-container {
  margin-bottom: 20px;
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
}
.main-header-container .main-header {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
  flex-wrap: wrap;
}
.main-header-container .main-header .main-header-title {
  font-size: 1.25rem;
  flex-basis: 100%;
  font-weight: 500;
}
.main-header-container .main-header .main-header-icon {
  color: rgba(28, 129, 158, 0.8);
  font-size: 28px;
  margin-right: 10px;
  align-self: center;
  text-shadow: 2px 2px lightgray;
}

.main-aside-open {
  padding-right: 320px;
}

.main-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
}

.sunken {
  box-shadow: 1px 3px 5px -1px rgba(0, 0, 0, 0.2) inset, 1px 6px 10px 0 rgba(0, 0, 0, 0.14) inset, 1px 1px 18px 0 rgba(0, 0, 0, 0.12) inset;
}

.gray {
  color: gray;
}

.silver {
  color: #C3CDE6;
}

.gold {
  color: gold;
}

.brown {
  color: brown;
}

.fbox {
  flex: 1;
  display: flex;
}

.vflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: column;
  flex-direction: column;
}

.hflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

.shadow-gray {
  border: 1px solid lightgray;
  box-shadow: 2px 2px 5px 1px lightgray;
}

.space-between {
  /* previous syntax */
  -ms-box-pack: justify;
  box-pack: justify;
  /* current syntax */
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}

.flex-left {
  justify-self: flex-start;
  margin-right: auto;
}

.flex-right {
  justify-self: flex-end;
  margin-left: auto;
}

.right-margin-20 {
  margin-right: 20px;
}

.left-margin-20 {
  margin-left: 20px;
}

.bottom-margin-20 {
  margin-bottom: 20px;
}

.bottom-margin-30 {
  margin-bottom: 30px;
}

.bottom-margin-40 {
  margin-bottom: 40px;
}

.top-margin-20 {
  margin-top: 20px;
}

.top-margin-40 {
  margin-top: 40px;
}

.margin-auto {
  margin: auto;
}

.h-margin-auto {
  margin-right: auto;
  margin-left: auto;
}

.v-margin-auto {
  margin-top: auto;
  margin-bottom: auto;
}

.flex-30 {
  flex: 0 0 30%;
}

.flex-90 {
  flex: 0 0 90%;
}

.padding-right-10 {
  padding-right: 10%;
}

.modal-dialog.modal-fullscreen-url-viewer-down {
  width: 90vw;
  max-width: none;
  height: 100%;
  margin: auto;
  padding-top: 30px;
}
.modal-dialog.modal-fullscreen-url-viewer-down .modal-body {
  padding: 1rem;
}

.suggestion-html-content > a {
  color: #067272;
  font-weight: 500;
  cursor: auto;
}

@media (min-width: 800px) {
  .modal-dialog {
    max-width: -moz-fit-content;
    max-width: fit-content;
  }
}
.modal-body .h6, .modal-body .h6, .modal-body h5, .modal-body .h5, .modal-body h4, .modal-body .h4, .modal-body h3, .modal-body .h3, .modal-body h2, .modal-body .h2, .modal-body h1, .modal-body .h1 {
  margin-bottom: 1.25rem;
  color: #022B2A;
}

/* The styles above for the modal-body, footer, etc aren't being applied so I tried the ones below and they work */
.modal-body {
  height: 100%;
}

.light-style__logo-container img {
  width: 170px;
  display: flex;
  /* padding: 0px; */
  align-items: center;
  background: none;
  border: 0px;
  border-radius: 3px;
  color: inherit;
  cursor: pointer;
  margin: 20px;
}

.light-style__floating-form-container {
  width: 350px;
  margin: 20px auto;
  background-color: inherit;
  border-radius: 15px;
  padding: 4px;
}

.light-style__form-group {
  margin-top: 20px;
}
.light-style__form-group label {
  display: block;
  margin-bottom: 10px;
}
.light-style__form-group input {
  min-width: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
  border: 1px solid #c4c7cf;
  border-radius: 6px;
  box-sizing: border-box;
  color: #191b23;
  font-size: inherit;
  text-overflow: ellipsis;
  font-family: inherit;
}

.light-style__form-divider {
  position: relative;
  margin-top: 14px;
  margin-bottom: 16px;
  text-align: center;
  border-top: 1px solid #d1d4db;
}
.light-style__form-divider .divider-inner {
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
}
.light-style__form-divider .divider-inner .divider-text {
  background-color: #fff;
  padding: 0 25px;
  font-size: 14px;
}

.light-style__quiet-link {
  display: inline-block;
  font-family: inherit;
  color: #006dca;
  line-height: normal;
  position: relative;
  cursor: pointer;
  -webkit-text-decoration: none;
  text-decoration: none;
  border: 0;
  padding: 0;
  margin: 0;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
  outline: 0;
  background: 0 0;
  transition: color 0.15s ease-in-out;
}

.light-style__button_form-submit {
  background-color: rgba(205, 227, 227, 0.8);
  width: 100%;
  border: 0;
  position: relative;
  margin-bottom: 12px;
  height: 40px;
  border-radius: 6px;
  font-size: 16px;
}

.light-style__button_third-party-auth {
  background-color: #fff;
  width: 100%;
  border: 1px solid #c4c7cf;
  position: relative;
  margin-bottom: 12px;
  height: 40px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}
.light-style__button_third-party-auth img {
  margin-top: -4px;
}

.button_full-width {
  width: 100%;
}

.light-style__cancel-button {
  background-color: #fff;
  border: 1px solid #022B2A;
  color: #022B2A;
  padding: 10px 16px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 6px;
}

.light-style__confirm-button {
  background-color: #022B2A;
  border: 1px solid #022B2A;
  color: #fff;
  padding: 10px 16px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 6px;
}

main.light-style__page-container {
  padding: 20px 40px;
  max-width: 1080px;
}
main.light-style__page-container h5, main.light-style__page-container .h5 {
  font-size: 1.625rem;
}
main.light-style__page-container .page-header {
  margin: 0;
}
main.light-style__page-container section {
  margin-bottom: 30px;
}
main.light-style__page-container .section-discription {
  font-size: 1em;
  color: lightslategray;
  margin-bottom: 20px;
}

.light-style__modal-container > * {
  padding: 1rem 2rem;
}
.light-style__modal-container h5, .light-style__modal-container .h5 {
  font-size: 1.625rem;
}
.light-style__modal-container h6 {
  color: #022B2A;
  font-weight: bold;
}
.light-style__modal-container .modal-header {
  display: flex;
  flex-direction: column;
  align-items: normal;
  border-bottom: 1px solid #E5E5E5;
}
.light-style__modal-container .page-header {
  margin: 0;
}
.light-style__modal-container section {
  margin-bottom: 30px;
}
.light-style__modal-container .section-discription {
  font-size: 1em;
  color: lightslategray;
}

.card-container {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  flex-wrap: wrap;
}
.card-container > * {
  flex: 0 1 24%;
  margin-bottom: 2%;
  border-radius: 10px;
  border: 1px solid rgba(229, 229, 255, 0.8);
  padding: 16px;
}

.commitments-tab-container .nav-tabs {
  border-bottom: 2px solid #dee2e6;
}
.commitments-tab-container .nav-tabs button {
  font-size: 1.1rem;
  color: #717D96;
  font-weight: 600;
}
.commitments-tab-container li {
  position: relative;
  top: 1px;
}
.commitments-tab-container .nav-tabs .nav-link.active, .commitments-tab-container .nav-tabs .nav-item.show .nav-link {
  color: #015659;
  border-bottom: 2px solid #015659;
}
.commitments-tab-container .nav-tabs .nav-link.active img, .commitments-tab-container .nav-tabs .nav-item.show .nav-link img {
  filter: invert(26%) sepia(92%) saturate(2538%) hue-rotate(169deg) brightness(100%) contrast(42%);
}
.commitments-tab-container img {
  height: 27px;
  filter: invert(49%) sepia(10%) saturate(912%) hue-rotate(182deg) brightness(96%) contrast(79%);
}
.commitments-tab-container .nav-link {
  color: inherit;
}
.commitments-tab-container .nav-item button {
  border: none;
}

.card-content {
  font-size: 1em;
  text-decoration: none;
  color: black;
  overflow: hidden;
  max-width: inherit;
  text-overflow: ellipsis;
  padding: 10px;
}

.no-outline {
  outline: none;
  position: static;
}

.stat-card-title {
  font-size: 0.75em;
  font-weight: 500;
  margin-bottom: 10px;
  color: #717D96;
}

.stat-card-value {
  font-size: 2.15rem;
  font-weight: 600;
}

.tab-container {
  margin-bottom: 30px;
}

.commitment-table-container {
  border: 1px solid #CBD2E0;
  border-radius: 10px;
}

#commitment-table.table {
  color: #2D3648;
  margin-bottom: 0;
}
#commitment-table.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
}
#commitment-table.table .collasped-buttons {
  display: flex;
  justify-content: end;
}
#commitment-table.table .expanded-buttons {
  display: none;
}
#commitment-table.table.table-hover tbody tr:hover .collasped-buttons {
  display: none;
}
#commitment-table.table.table-hover tbody tr:hover .expanded-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
#commitment-table.table.table-hover tbody tr:hover .expanded-buttons img {
  cursor: pointer;
}
#commitment-table.table .commitment-table-header th {
  padding-top: 10px;
  padding-bottom: 10px;
  border-color: #CBD2E0;
}
#commitment-table.table .commitment-table-header th:first-child {
  border-top-left-radius: 10px;
  padding-left: 1rem;
  line-height: 0;
}
#commitment-table.table .commitment-table-header th:last-child {
  border-top-right-radius: 10px;
}
#commitment-table.table .commitment-table-header th:nth-child(3) {
  text-align: center;
}
#commitment-table.table .commitment-table-row {
  font-size: 0.875rem;
}
#commitment-table.table .commitment-table-row td:first-child {
  line-height: 25px;
  padding-left: 1rem;
  line-height: 0;
}
#commitment-table.table .commitment-table-row:last-child {
  border-bottom-color: rgba(0, 0, 0, 0);
}
#commitment-table.table .commitment-table-row td:nth-child(1) {
  width: 40px;
}
#commitment-table.table .commitment-table-row td:nth-child(2) {
  width: 35%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 340px;
}
#commitment-table.table .commitment-table-row td:nth-child(3) {
  width: 20%;
  text-align: center;
}
#commitment-table.table .commitment-table-row td:nth-child(5) {
  width: 100px;
}
#commitment-table.table .status-badge {
  border-radius: 8px;
  width: 126px;
  display: flex;
  padding: 5px;
  justify-content: center;
  cursor: default;
}
#commitment-table.table .status-badge :first-child {
  margin-right: 0.125rem;
}
#commitment-table.table .status-verified {
  color: #015659;
  background-color: rgba(103, 189, 140, 0.2);
}
#commitment-table.table .status-pending {
  color: #2D3648;
  background-color: rgb(237, 240, 247);
}
#commitment-table.table .status-unlinked {
  color: #E8B44D;
  background-color: rgba(232, 180, 77, 0.2);
}

.inbound-table-container {
  border: 1px solid #CBD2E0;
  border-radius: 10px;
}

#inbound-table.table {
  color: #2D3648;
  margin-bottom: 0;
}
#inbound-table.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
}
#inbound-table.table .menu-button .button-container {
  display: none;
}
#inbound-table.table .menu-button .collasped-buttons {
  display: flex;
  font-style: italic;
}
#inbound-table.table .menu-button .expanded-buttons {
  display: flex;
  flex-direction: row;
}
#inbound-table.table .menu-button button {
  border-radius: 4px;
  width: 110px;
  display: flex;
  padding: 5px;
  justify-content: center;
  border: 2px solid #022B2A;
}
#inbound-table.table .menu-button button :first-child {
  margin-right: 0.125rem;
}
#inbound-table.table .menu-button .approve-button {
  background-color: #022B2A;
  color: #FFFFFF;
  margin-right: 1.5rem;
}
#inbound-table.table .menu-button .disavow-button {
  background-color: #FFFFFF;
  color: #022B2A;
}
#inbound-table.table .menu-button .approved-accent {
  font-weight: 700;
}
#inbound-table.table .commitment-table-header th {
  padding-top: 10px;
  padding-bottom: 10px;
  border-color: #CBD2E0;
}
#inbound-table.table .commitment-table-header th:first-child {
  border-top-left-radius: 10px;
  padding-left: 1rem;
  line-height: 0;
}
#inbound-table.table .commitment-table-header th:last-child {
  border-top-right-radius: 10px;
}
#inbound-table.table .commitment-table-header th:nth-child(3) {
  text-align: center;
}
#inbound-table.table .commitment-table-row {
  font-size: 0.875rem;
}
#inbound-table.table .commitment-table-row td:first-child {
  line-height: 25px;
  padding-left: 1rem;
  line-height: 0;
}
#inbound-table.table .commitment-table-row:last-child {
  border-bottom-color: rgba(0, 0, 0, 0);
}
#inbound-table.table .commitment-table-row td:nth-child(1) {
  width: 40px;
}
#inbound-table.table .commitment-table-row td:nth-child(2) {
  width: 35%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 340px;
}
#inbound-table.table .commitment-table-row td:nth-child(3) {
  width: 20%;
  text-align: center;
}
#inbound-table.table .commitment-table-row td:nth-child(5) {
  width: 100px;
}

.regular-checkbox {
  -webkit-appearance: none;
  appearance: none;
  border: 1px solid #cacece;
  padding: 9px;
  border-radius: 3px;
  display: inline-block;
  position: relative;
}

.regular-checkbox:active, .regular-checkbox:checked:active {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px 1px 3px rgba(0, 0, 0, 0.1);
}

.regular-checkbox:checked {
  background-color: inherit;
}

.regular-checkbox:checked:after {
  content: "✔";
  font-size: 14px;
  position: absolute;
  left: 3px;
  color: #99a1a7;
}

.empty-grid-message {
  font-size: 1.5em;
  color: #717D96;
  margin: 20px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/views/commitments/commitments.component.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/mixins.scss","webpack://./src/scss/main.scss","webpack://./src/scss/overrides.scss","webpack://./src/scss/light-style.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACUhB;EACI,WAAA;ADRJ;;ACUA;EACI,cAAA;ADPJ;;ACSA;EACI,WAAA;ADNJ;;ACQA;EACI,YAAA;ADLJ;;AEmFA;EACE,OAAA;EACA,aAAA;AFhFF;;AEmFA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,2BAAA;EAEK,sBAAA;AFjFV;;AEoFA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,wBAAA;EAEK,mBAAA;AFlFV;;AEqFA;EAEI,mBAAA;EACA,uBAAA;AFnFJ;;AEsFA;EACI,2BAAA;EACA,qCAAA;AFnFJ;;AEsFA;EACI,oBAAA;EAGI,qBAAA;EACI,iBAAA;EAER,mBAAA;EAEI,mCAAA;EACA,kCAAA;EACI,8BAAA;AFpFZ;;AEuFA;EACI,wBAAA;EACA,kBAAA;AFpFJ;;AEuFA;EACI,sBAAA;EACA,iBAAA;AFpFJ;;AEuFA;EACI,kBAAA;AFpFJ;;AEuFA;EACI,iBAAA;AFpFJ;;AEuFA;EACI,mBAAA;AFpFJ;;AEuFA;EACI,mBAAA;AFpFJ;;AEuFA;EACI,mBAAA;AFpFJ;;AEuFA;EACI,gBAAA;AFpFJ;;AEuFA;EACI,gBAAA;AFpFJ;;AEuFA;EACI,YAAA;AFpFJ;;AEsFA;EACI,kBAAA;EACA,iBAAA;AFnFJ;;AEqFA;EACI,gBAAA;EACA,mBAAA;AFlFJ;;AEqFA;EACI,aAAA;AFlFJ;;AEqFA;EACI,aAAA;AFlFJ;;AEqFA;EACI,kBAAA;AFlFJ;;AG/HA;EACI,oBAAA;EAGI,eAAA;EACI,WAAA;EAER,mBAAA;EAEI,YAAA;EAEI,OAAA;EAER,YAAA;EACA,WAAA;EACA,SAAA;EAGA,gBAAA;AH8HJ;;AG3HA;EAEI,mBAAA;EDRA,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGI,wBAAA;EAEI,mBAAA;AFqIZ;AGlII;EDZA,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGI,wBAAA;EAEI,mBAAA;ECKJ,eAAA;AH4IR;AG3IQ;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AH6IZ;AG1IQ;EACI,8BFrCG;EEsCH,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;AH4IZ;;AGvIA;EACI,oBAAA;AH0IJ;;AGvIA;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;AH0IJ;;AGnIA;EACI,yIACI;AHqIR;;AC9LA;EACI,WAAA;ADiMJ;;AC/LA;EACI,cAAA;ADkMJ;;AChMA;EACI,WAAA;ADmMJ;;ACjMA;EACI,YAAA;ADoMJ;;AEtHA;EACE,OAAA;EACA,aAAA;AFyHF;;AEtHA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,2BAAA;EAEK,sBAAA;AFwHV;;AErHA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,wBAAA;EAEK,mBAAA;AFuHV;;AEpHA;EAEI,mBAAA;EACA,uBAAA;AFsHJ;;AEnHA;EACI,2BAAA;EACA,qCAAA;AFsHJ;;AEnHA;EACI,oBAAA;EAGI,qBAAA;EACI,iBAAA;EAER,mBAAA;EAEI,mCAAA;EACA,kCAAA;EACI,8BAAA;AFqHZ;;AElHA;EACI,wBAAA;EACA,kBAAA;AFqHJ;;AElHA;EACI,sBAAA;EACA,iBAAA;AFqHJ;;AElHA;EACI,kBAAA;AFqHJ;;AElHA;EACI,iBAAA;AFqHJ;;AElHA;EACI,mBAAA;AFqHJ;;AElHA;EACI,mBAAA;AFqHJ;;AElHA;EACI,mBAAA;AFqHJ;;AElHA;EACI,gBAAA;AFqHJ;;AElHA;EACI,gBAAA;AFqHJ;;AElHA;EACI,YAAA;AFqHJ;;AEnHA;EACI,kBAAA;EACA,iBAAA;AFsHJ;;AEpHA;EACI,gBAAA;EACA,mBAAA;AFuHJ;;AEpHA;EACI,aAAA;AFuHJ;;AEpHA;EACI,aAAA;AFuHJ;;AEpHA;EACI,kBAAA;AFuHJ;;AIjUA;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AJoUJ;AIlUI;EACE,aAAA;AJoUN;;AI3TA;EACE,cAAA;EACA,gBAAA;EACA,YAAA;AJ8TF;;AIrTA;EAEE;IACE,2BAAA;IAAA,sBAAA;EJuTF;AACF;AIhTE;EACE,sBAAA;EACA,cAAA;AJkTJ;;AI9OE,kHAAA;AACA;EACE,YAAA;AJiPJ;;AK1WA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AL6WJ;;AK1WA;EACI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AL6WJ;;AK1WA;EACI,gBAAA;AL6WJ;AK3WI;EACI,cAAA;EACA,mBAAA;AL6WR;AK1WI;EAKI,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;ALwWR;;AKpWA;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;ALuWJ;AKtWI;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;ALwWR;AKvWQ;EACI,sBAAA;EACA,eAAA;EACA,eAAA;ALyWZ;;AKjWA;EACI,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,wCAAA;EACA,UAAA;EACA,eAAA;EACA,mCAAA;ALoWJ;;AK9VA;EACI,0CAAA;EACA,WAAA;EACA,SAAA;EAEA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;ALgWJ;;AK7VA;EACI,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ALgWJ;AK9VI;EACI,gBAAA;ALgWR;;AK5VA;EACI,WAAA;AL+VJ;;AK5VA;EACI,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AL+VJ;;AK5VA;EACI,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AL+VJ;;AKzVA;EAEI,kBAAA;EACA,iBAAA;AL2VJ;AKxVI;EACI,mBAAA;AL0VR;AKvVI;EACI,SAAA;ALyVR;AKtVI;EACI,mBAAA;ALwVR;AKrVI;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;ALuVR;;AKlVI;EACI,kBAAA;ALqVR;AKlVI;EACI,mBAAA;ALoVR;AKjVI;EACI,cAAA;EACA,iBAAA;ALmVR;AKhVI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gCAAA;ALkVR;AK/UI;EACI,SAAA;ALiVR;AK9UI;EACI,mBAAA;ALgVR;AK7UI;EACI,cAAA;EACA,qBAAA;AL+UR;;AAvhBA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;AA0hBJ;AAzhBI;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EAEA,0CAAA;EACA,aAAA;AA0hBR;;AArhBI;EACI,gCAAA;AAwhBR;AAthBI;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;AAwhBR;AArhBI;EACI,kBAAA;EACA,QAAA;AAuhBR;AAphBI;EACI,cAAA;EACA,gCAAA;AAshBR;AAphBQ;EACI,gGAAA;AAshBZ;AAlhBI;EACI,YAAA;EACA,8FAAA;AAohBR;AAjhBI;EAGI,cAAA;AAihBR;AA5gBI;EACI,YAAA;AA8gBR;;AA1gBA;EAEI,cAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;AA4gBJ;;AAzgBA;EACI,aAAA;EACA,gBAAA;AA4gBJ;;AA5fA;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA+fJ;;AA5fA;EACI,kBAAA;EACA,gBAAA;AA+fJ;;AA1fA;EACI,mBAAA;AA6fJ;;AA1fA;EACI,yBAAA;EACA,mBAAA;AA6fJ;;AAzfA;EAEI,cAAA;EACA,gBAAA;AA2fJ;AA1fI;EACI,sBAAA;AA4fR;AAhfI;EACI,aAAA;EACA,oBAAA;AAkfR;AAhfI;EACI,aAAA;AAkfR;AA9eQ;EACI,aAAA;AAgfZ;AA9eQ;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;AAgfZ;AA9eY;EACI,eAAA;AAgfhB;AA1eQ;EACI,iBAAA;EACA,oBAAA;EACA,qBAAA;AA4eZ;AA1eQ;EACI,4BAAA;EACA,kBAAA;EACA,cAAA;AA4eZ;AA1eQ;EACI,6BAAA;AA4eZ;AA1eQ;EACI,kBAAA;AA4eZ;AAxeI;EACI,mBAAA;AA0eR;AAveQ;EACI,iBAAA;EACA,kBAAA;EACA,cAAA;AAyeZ;AAveQ;EAEI,qCAAA;AAweZ;AAreQ;EACI,WAAA;AAueZ;AAreQ;EACI,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAueZ;AAreQ;EACI,UAAA;EACA,kBAAA;AAueZ;AAleQ;EACI,YAAA;AAoeZ;AAjeI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AAmeR;AAjeQ;EACI,sBAAA;AAmeZ;AAheI;EACI,cAAA;EACA,0CAAA;AAkeR;AAheI;EACI,cAAA;EAEA,oCAAA;AAieR;AA/dI;EACI,cAAA;EACA,yCAAA;AAieR;;AA3dA;EACI,yBAAA;EACA,mBAAA;AA8dJ;;AA3dA;EAEI,cAAA;EACA,gBAAA;AA6dJ;AA5dI;EACI,sBAAA;AA8dR;AAzdQ;EACI,aAAA;AA2dZ;AAzdQ;EACI,aAAA;EACA,kBAAA;AA2dZ;AAzdQ;EACI,aAAA;EACA,mBAAA;AA2dZ;AAzdQ;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;AA2dZ;AAzdY;EACI,sBAAA;AA2dhB;AAxdQ;EACI,yBAAA;EACA,cAAA;EACA,oBAAA;AA0dZ;AAxdQ;EACI,yBAAA;EACA,cAAA;AA0dZ;AAxdQ;EACI,gBAAA;AA0dZ;AApdQ;EACI,iBAAA;EACA,oBAAA;EACA,qBAAA;AAsdZ;AApdQ;EACI,4BAAA;EACA,kBAAA;EACA,cAAA;AAsdZ;AApdQ;EACI,6BAAA;AAsdZ;AApdQ;EACI,kBAAA;AAsdZ;AAldI;EACI,mBAAA;AAodR;AAjdQ;EACI,iBAAA;EACA,kBAAA;EACA,cAAA;AAmdZ;AAjdQ;EAEI,qCAAA;AAkdZ;AA/cQ;EACI,WAAA;AAidZ;AA/cQ;EACI,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAidZ;AA/cQ;EACI,UAAA;EACA,kBAAA;AAidZ;AA5cQ;EACI,YAAA;AA8cZ;;AAxcA;EACA,wBAAA;EACA,gBAAA;EAEC,yBAAA;EAEA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAycD;;AAtcA;EACC,+EAAA;AAycD;;AAtcA;EACC,yBAAA;AAycD;;AAtcA;EACC,YAAA;EACA,eAAA;EACA,kBAAA;EAEA,SAAA;EACA,cAAA;AAwcD;;AArcA;EACI,gBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AAwcJ","sourcesContent":["@import \"../../../scss/index.scss\";\n$table-cell-padding-y:        .5rem;\n$table-cell-padding-x:        1.5rem;\n$table-cell-padding-y-sm:     .25rem;\n$table-cell-padding-x-sm:     .25rem;\n\n.card-container{\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n    flex-wrap: wrap;\n    > * {\n        flex: 0 1 24%;\n        margin-bottom: 2%;\n        border-radius: 10px;\n        // background-color: rgba(229, 229, 229, 30%);\n        border: 1px solid rgba(229, 229, 299, 80%);\n        padding: 16px;\n    }\n}\n\n.commitments-tab-container {\n    .nav-tabs {\n        border-bottom: 2px solid #dee2e6;\n    }\n    .nav-tabs button {\n        font-size: 1.1rem;\n        color: #717D96;\n        font-weight: 600;\n    }\n\n    li { // Allow borders to overlap\n        position: relative;\n        top: 1px;\n    }\n\n    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {\n        color: #015659;\n        border-bottom: 2px solid #015659;\n\n        img {\n            filter: invert(26%) sepia(92%) saturate(2538%) hue-rotate(169deg) brightness(100%) contrast(42%);\n        }\n    }\n\n    img {\n        height: 27px;\n        filter: invert(49%) sepia(10%) saturate(912%) hue-rotate(182deg) brightness(96%) contrast(79%);\n    }\n\n    .nav-link {\n        //display: block;\n        //padding: 0.5rem 1rem;\n        color: inherit;\n        //text-decoration: none;\n        //transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n    }\n\n    .nav-item button {\n        border: none;\n    }\n}\n\n.card-content {\n    //font-weight: 500;\n    font-size: 1em;\n    text-decoration: none;\n    color: black;\n    overflow: hidden;\n    max-width: inherit;\n    text-overflow: ellipsis;\n    padding: 10px;\n}\n\n.no-outline {\n    outline: none;\n    position: static;\n}\n\n// Cards\n// .stat-card {\n//     border-radius: 10px;\n//     background-color: rgba(229, 229, 229, 30%);\n//     border: 1px solid rgba(229, 229, 299, 80%);\n//     padding: 16px;\n//     flex: 1 0 24%;\n//     height: 100%;\n//     // &:nth-last-child(n+2) {\n//     //     margin-right: 20px;\n//     // }\n// }\n\n.stat-card-title {\n    font-size: 0.75em;\n    font-weight: 500;\n    margin-bottom: 10px;\n    color: #717D96;\n}\n\n.stat-card-value {\n    font-size: 2.15rem;\n    font-weight: 600;\n}\n\n\n//Start grid styling\n.tab-container {\n    margin-bottom: 30px;\n}\n\n.commitment-table-container {\n    border: 1px solid #CBD2E0;\n    border-radius: 10px;\n}\n\n\n#commitment-table.table \n{\n    color: #2D3648;\n    margin-bottom: 0;\n    > :not(caption) > * > * {\n        padding: 0.5rem 0.5rem;\n    }\n\n    // .collasped-buttons {\n    //     display: none;\n    // }\n    // .expanded-buttons {\n    //     display: flex;\n    //     flex-direction: row;\n    //     justify-content: space-around;\n    // }\n\n    .collasped-buttons {\n        display: flex;\n        justify-content: end;\n    }\n    .expanded-buttons {\n        display: none;\n    }\n\n    &.table-hover tbody tr:hover {\n        .collasped-buttons {\n            display: none;\n        }\n        .expanded-buttons {\n            display: flex;\n            flex-direction: row;\n            justify-content: space-around;\n\n            img {\n                cursor: pointer;\n            }\n        }\n    }\n\n    .commitment-table-header {\n        th{\n            padding-top: 10px;\n            padding-bottom: 10px;\n            border-color: #CBD2E0;\n        }\n        th:first-child {\n            border-top-left-radius: 10px;\n            padding-left: 1rem;\n            line-height: 0;\n        }\n        th:last-child {\n            border-top-right-radius: 10px;\n        }\n        th:nth-child(3) {\n            text-align: center;\n        }\n    } \n    \n    .commitment-table-row {\n        font-size: 0.875rem;\n        //display: flex;\n        \n        td:first-child  {\n            line-height: 25px; \n            padding-left: 1rem;\n            line-height: 0;\n        }\n        &:last-child\n        {\n            border-bottom-color: rgba(0, 0, 0, 0);\n        }\n\n        td:nth-child(1) {\n            width: 40px;\n        } \n        td:nth-child(2) {\n            width: 35%;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            max-width: 340px;   // This needs to be set using pixels, not percent, should just media breakpoints  \n        } \n        td:nth-child(3) {\n            width: 20%;\n            text-align: center;\n        } \n        td:nth-child(4) {\n            //width: 30%;\n        }\n        td:nth-child(5) {\n            width: 100px;\n        } \n    }\n    .status-badge {\n        border-radius: 8px;\n        width: 126px;\n        display: flex;\n        padding: 5px;\n        justify-content: center;\n        cursor: default;\n\n        :first-child {\n            margin-right: 0.125rem;\n        }\n    }\n    .status-verified {\n        color: #015659;\n        background-color: rgba(103, 189, 140, 20%);;\n    }\n    .status-pending {\n        color: #2D3648;\n        //background-color: #EDF0F7;\n        background-color: rgba(237, 240, 247, 100%);;\n    }\n    .status-unlinked {\n        color: #E8B44D;\n        background-color: rgba(232, 180, 77, 20%);;\n        //background-color: #EDD356;\n        //color: #BA851E;\n    }\n}\n\n.inbound-table-container {\n    border: 1px solid #CBD2E0;\n    border-radius: 10px;\n}\n\n#inbound-table.table \n{\n    color: #2D3648;\n    margin-bottom: 0;\n    > :not(caption) > * > * {\n        padding: 0.5rem 0.5rem;\n    }\n\n    .menu-button \n    {\n        .button-container {\n            display:none;\n        }\n        .collasped-buttons {\n            display: flex;\n            font-style: italic;\n        }\n        .expanded-buttons {\n            display: flex;\n            flex-direction: row;\n        }\n        button {\n            border-radius: 4px;\n            width: 110px;\n            display: flex;\n            padding: 5px;\n            justify-content: center;\n            border: 2px solid #022B2A;\n\n            :first-child {\n                margin-right: 0.125rem;\n            }\n        }\n        .approve-button {\n            background-color: #022B2A;\n            color: #FFFFFF;\n            margin-right: 1.5rem;\n        }\n        .disavow-button {\n            background-color: #FFFFFF;\n            color: #022B2A;\n        }\n        .approved-accent {\n            font-weight: 700;\n        }\n    }\n    \n    .commitment-table-header\n    {\n        th{\n            padding-top: 10px;\n            padding-bottom: 10px;\n            border-color: #CBD2E0;\n        }\n        th:first-child {\n            border-top-left-radius: 10px;\n            padding-left: 1rem;\n            line-height: 0;\n        }\n        th:last-child {\n            border-top-right-radius: 10px;\n        }\n        th:nth-child(3) {\n            text-align: center;\n        }\n    } \n    \n    .commitment-table-row {\n        font-size: 0.875rem;\n        //display: flex;\n        \n        td:first-child  {\n            line-height: 25px; \n            padding-left: 1rem;\n            line-height: 0;\n        }\n        &:last-child\n        {\n            border-bottom-color: rgba(0, 0, 0, 0);\n        }\n\n        td:nth-child(1) {\n            width: 40px;\n        } \n        td:nth-child(2) {\n            width: 35%;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            max-width: 340px;   // This needs to be set using pixels, not percent, should just media breakpoints  \n        } \n        td:nth-child(3) {\n            width: 20%;\n            text-align: center;\n        } \n        td:nth-child(4) {\n            //width: 30%;\n        }\n        td:nth-child(5) {\n            width: 100px;\n        } \n    }\n}\n\n// Checkbox Styling - Todo: move to shared styling\n.regular-checkbox {\n-webkit-appearance: none;\nappearance: none;\n\t// background-color: #fafafa;\n\tborder: 1px solid #cacece;\n\t// box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05);\n\tpadding: 9px;\n\tborder-radius: 3px;\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\n.regular-checkbox:active, .regular-checkbox:checked:active {\n\tbox-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px 1px 3px rgba(0,0,0,0.1);\n}\n\n.regular-checkbox:checked {\n\tbackground-color: inherit \n}\n\n.regular-checkbox:checked:after {\n\tcontent: '\\2714';\n\tfont-size: 14px;\n\tposition: absolute;\n\t//top: 0px;\n\tleft: 3px;\n\tcolor: #99a1a7;\n}\n\n.empty-grid-message {\n    font-size: 1.5em;\n    color: #717D96;\n    margin: 20px;\n    text-align: center;\n}\n","$gray: gray !default;\n$silver: #C3CDE6 !default;\n$gold: gold !default;\n$brown: brown !default;\n$andrena-blue: rgba(28, 129, 158, 0.8);\n$black: black !default;\n$lightgray: lightgray !default;\n$darkgray: darkgray !default;\n$white: white !default;\n\n.gray {\n    color: gray;\n}\n.silver {\n    color:#C3CDE6;\n}\n.gold {\n    color: gold;\n}\n.brown {\n    color: brown;\n}\n  ","@mixin fbox {\n    flex:1;\n    display: flex;\n}\n  \n@mixin vflex {\n    /* current syntax */\n    display: -webkit-flex;\n    display:    -moz-flex;\n    display:     -ms-flex;\n    display:         flex;\n\n    -webkit-flex-direction: column;\n        -moz-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n\n@mixin hflex {\n    /* current syntax */\n    display: -webkit-flex;\n    display:    -moz-flex;\n    display:     -ms-flex;\n    display:         flex;\n\n    -webkit-flex-direction: row;\n        -moz-flex-direction: row;\n        -ms-flex-direction: row;\n            flex-direction: row;\n}\n\n@mixin overflow-hidden {\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n@mixin shadow-gray {\n    box-shadow: 2px 2px 0px 0px $lightgray,\n}\n\n@mixin center-margin {\n    margin-right: auto;\n    margin-left: auto;\n}\n\n@mixin shadow1 {\n    box-shadow: 2px 2px 0px 0px $lightgray,\n        0px 0px 6px 0px $lightgray;\n}\n\n@mixin border1 {\n    border: 1px solid $lightgray;\n}\n\n@mixin rounded-border1 {\n    border: 1px solid $lightgray;\n    border-radius: 8px;\n}\n\n@mixin space-between {\n    /* previous syntax */\n    -webkit-box-pack: justify;\n    -moz-box-pack: justify;\n    -ms-box-pack: justify;\n        box-pack: justify;\n\n    /* current syntax */\n    -webkit-justify-content: space-between;\n    -moz-justify-content: space-between;\n    -ms-justify-content: space-between;\n        justify-content: space-between;\n}\n\n@mixin flex-left {\n    justify-self: flex-start;\n    margin-right: auto;\n}\n\n@mixin flex-right {\n    justify-self: flex-end;\n    margin-left: auto;\n}\n\n@mixin sunken {\n    box-shadow: \n        1px 3px 5px -1px rgb(0 0 0 / 20%) inset, \n        1px 6px 10px 0 rgb(0 0 0 / 14%) inset, \n        1px 1px 18px 0 rgb(0 0 0 / 12%) inset;\n}\n\n@mixin hive-splash1 {\n    content: \"\";\n    background-image: url(\"/assets/bg1.jpg\");\n    opacity: 1;\n    background-repeat: no-repeat;\n    background-size: cover; \n}\n\n.fbox {\n  flex:1;\n  display: flex;\n}\n\n.vflex {\n  /* current syntax */\n  display: -webkit-flex;\n  display:    -moz-flex;\n  display:     -ms-flex;\n  display:         flex;\n\n  -webkit-flex-direction: column;\n     -moz-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.hflex {\n  /* current syntax */\n  display: -webkit-flex;\n  display:    -moz-flex;\n  display:     -ms-flex;\n  display:         flex;\n\n  -webkit-flex-direction: row;\n     -moz-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n\n.flex-center {\n    //display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.shadow-gray {\n    border: 1px solid $lightgray;      \n    box-shadow: 2px 2px 5px 1px $lightgray;\n}\n\n.space-between {\n    /* previous syntax */\n    -webkit-box-pack: justify;\n        -moz-box-pack: justify;\n        -ms-box-pack: justify;\n            box-pack: justify;\n\n    /* current syntax */\n    -webkit-justify-content: space-between;\n        -moz-justify-content: space-between;\n        -ms-justify-content: space-between;\n            justify-content: space-between;\n}\n\n.flex-left {\n    justify-self: flex-start;\n    margin-right: auto;\n}\n\n.flex-right {\n    justify-self: flex-end;\n    margin-left: auto;\n}\n\n.right-margin-20 {\n    margin-right: 20px;\n}\n\n.left-margin-20 {\n    margin-left: 20px;\n}\n\n.bottom-margin-20 {\n    margin-bottom: 20px;\n}\n\n.bottom-margin-30 {\n    margin-bottom: 30px;\n}\n\n.bottom-margin-40 {\n    margin-bottom: 40px;\n}\n\n.top-margin-20 {\n    margin-top: 20px;\n}\n\n.top-margin-40 {\n    margin-top: 40px;\n}\n\n.margin-auto {\n    margin:auto\n}\n.h-margin-auto {\n    margin-right: auto;\n    margin-left: auto;\n}\n.v-margin-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.flex-30 {\n    flex: 0 0 30%;\n}\n\n.flex-90 {\n    flex: 0 0 90%;\n}\n\n.padding-right-10 {\n    padding-right: 10%;\n}","@import './colors.scss';\n@import './mixins.scss';\n\n// Styles for main view container\n.main {\n    /* previous syntax */\n    -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -ms-box-flex: 1;\n            box-flex: 1;\n\n    /* current syntax */\n    -webkit-flex: 1;\n        -moz-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n\n    height: 100%;\n    width: 100%;\n    margin: 0;\n    //padding: 10px;\n    //padding: 10px 6% 10px 6%;\n    overflow-y: auto;\n}\n\n.main-header-container {\n    //font-size: 20px;\n    margin-bottom: 20px;\n    // margin-top: 20px;\n    //font-family: 'Alice', serif;\n    @include hflex;\n    .main-header {\n        @include hflex;\n        flex-wrap: wrap;\n        .main-header-title {\n            font-size: 1.25rem;\n            flex-basis: 100%;\n            font-weight: 500;\n            //text-shadow: 2px 2px $lightgray;\n        }\n        .main-header-icon {\n            color: $andrena-blue;\n            font-size: 28px;\n            margin-right: 10px;\n            align-self: center;\n            text-shadow: 2px 2px $lightgray;\n        }\n    }\n}\n\n.main-aside-open {\n    padding-right: calc(320px + 0px);\n}\n\n.main-content {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    height: 100%;\n}\n\n.main-loading-container {\n    //Todo: add styling for loading \n}\n\n.sunken {\n    box-shadow: \n        1px 3px 5px -1px rgb(0 0 0 / 20%) inset, \n        1px 6px 10px 0 rgb(0 0 0 / 14%) inset, \n        1px 1px 18px 0 rgb(0 0 0 / 12%) inset;\n}\n","// button {\n//     background-color: inherit;\n// }\n\n// $table-cell-padding-y:        .5rem;\n// $table-cell-padding-x:        1.5rem;\n// $table-cell-padding-y-sm:     .25rem;\n// $table-cell-padding-x-sm:     .25rem;\n\n// modal overrides\n\n.modal-dialog.modal-fullscreen-url-viewer-down {\n    width: 90vw;\n    max-width: none;\n    height: 100%;\n    margin: auto;\n    padding-top: 30px;\n\n    .modal-body {\n      padding: 1rem;\n    }\n}\n\n.modal-dialog {\n  //max-width: 600px;\n  //margin: 8rem auto;\n}\n\n.suggestion-html-content > a {\n  color: #067272;\n  font-weight: 500;\n  cursor: auto;\n}\n\n\n// .modal-content {\n//   border-radius: 10px;\n//   padding: 1rem;\n// }\n\n@media (min-width: 800px)\n{\n  .modal-dialog {\n    max-width: fit-content;\n    //max-width: 600px;\n    //margin: 1.75rem auto;\n  }\n}\n\n.modal-body {\n  //padding: 2.4rem 2.4rem 2.4rem 2.4rem;\n  .h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n    margin-bottom: 1.25rem;\n    color: #022B2A;\n  }\n}\n\n\n\n// .myCustomModalClass {\n//     position: fixed;\n//     top: 20px;\n//     right: 20px;\n//     bottom: 20px;\n//     left: 20px;\n//     z-index: 1060;\n//     display: none;\n//     overflow: hidden;\n//     -webkit-overflow-scrolling: touch;\n//     outline: 0;\n// }\n\n// .modal.modal-fullscreen {\n//     /* Maximize the main wrappers on the screen */\n//     /* Make the parent wrapper of the modal box a full-width block */\n//     /* Remove borders and effects on the content */\n//     /**\n//        * /!\\ By using this feature, you force the header and footer to be placed\n//        * in an absolute position. You must handle by yourself the margin of the\n//        * content.\n//        */\n//   }\n//   .modal.modal-fullscreen .modal-dialog,\n//   .modal.modal-fullscreen .modal-content {\n//     bottom: 0;\n//     left: 0;\n//     position: absolute;\n//     right: 0;\n//     top: 0;\n//   }\n//   .modal.modal-fullscreen .modal-dialog {\n//     margin: 0;\n//     width: 100%;\n//     animation-duration:0.6s;\n//   }\n//   .modal.modal-fullscreen .modal-content {\n//     border: none;\n//     -moz-border-radius: 0;\n//     border-radius: 0;\n//     -webkit-box-shadow: inherit;\n//     -moz-box-shadow: inherit;\n//     -o-box-shadow: inherit;\n//     box-shadow: inherit;\n//     /* change bg color below */\n//    /* background:#1abc9c; */\n//   }\n//   .modal.modal-fullscreen.force-fullscreen {\n//     /* Remove the padding inside the body */\n//   }\n//   .modal.modal-fullscreen.force-fullscreen .modal-body {\n//     padding: 0;\n//   }\n//   .modal.modal-fullscreen.force-fullscreen .modal-header,\n//   .modal.modal-fullscreen.force-fullscreen .modal-footer {\n//     position: absolute;\n//     bottom: 0;\n//   }\n//   .modal.modal-fullscreen.force-fullscreen .modal-header {\n//     top: 0;\n//   }\n  \n  /* The styles above for the modal-body, footer, etc aren't being applied so I tried the ones below and they work */\n  .modal-body {\n    height: 100%;\n  }\n  \n  // .modal-footer {\n  //   width: 100%;\n  //   position: absolute;\n  //   bottom: 0;\n  //   background-color: #FFF;\n  // }\n  ","\n// Form styles\n.light-style__logo-container img {\n    width: 170px;\n    display: flex;\n    /* padding: 0px; */\n    align-items: center;\n    background: none;\n    border: 0px;\n    border-radius: 3px;\n    color: inherit;\n    cursor: pointer;\n    margin: 20px;\n}\n\n.light-style__floating-form-container {\n    width: 350px;\n    margin: 20px auto;\n    background-color: inherit;\n    border-radius: 15px;\n    padding: 4px;\n}\n\n.light-style__form-group {\n    margin-top: 20px;\n\n    label {\n        display: block;\n        margin-bottom: 10px;\n    }\n\n    input {\n        // width: 100%;\n        // padding: 10px;\n        // border-radius: 5px;\n        // border: 1px solid lightgray;\n        min-width: 0;\n        width: 100%;\n        height: 100%;\n        padding: 10px;\n        border: 1px solid #c4c7cf;\n        border-radius: 6px;\n        box-sizing: border-box;\n        color:  #191b23;\n        font-size: inherit;\n        text-overflow: ellipsis;\n        font-family: inherit;\n    }\n}\n\n.light-style__form-divider{\n    position: relative;\n    margin-top: 14px;\n    margin-bottom: 16px;\n    text-align: center;\n    border-top: 1px solid #d1d4db;\n    .divider-inner {\n        position: absolute;\n        top: -10px;\n        left: 0;\n        right: 0;\n        .divider-text {\n            background-color: #fff;\n            padding: 0 25px;\n            font-size: 14px;\n        }\n    }\n}\n\n// End Form styles\n\n// Link styles\n.light-style__quiet-link {\n    display: inline-block;\n    font-family: inherit;\n    color: #006dca;\n    line-height: normal;\n    position: relative;\n    cursor: pointer;\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    border: 0;\n    padding: 0;\n    margin: 0;\n    box-shadow: none;\n    -webkit-tap-highlight-color: transparent;\n    outline: 0;\n    background: 0 0;\n    transition: color .15s ease-in-out;\n}\n\n// End Link styles\n\n// Button styles\n.light-style__button_form-submit {\n    background-color: rgba(205, 227, 227, 0.8);\n    width: 100%;\n    border: 0;\n    //border: 1px solid rgba(205, 227, 227, 0.8);\n    position: relative;\n    margin-bottom: 12px;\n    height: 40px;\n    border-radius: 6px;\n    font-size: 16px;\n}\n\n.light-style__button_third-party-auth {\n    background-color: #fff;\n    width: 100%;\n    border: 1px solid #c4c7cf;\n    position: relative;\n    margin-bottom: 12px;\n    height: 40px;\n    border-radius: 6px;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 150%;\n\n    img {\n        margin-top: -4px;\n    }\n}\n\n.button_full-width {\n    width: 100%;\n}\n\n.light-style__cancel-button {\n    background-color: #fff;\n    border: 1px solid #022B2A;\n    color: #022B2A;\n    padding: 10px 16px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    border-radius: 6px;\n}\n\n.light-style__confirm-button {\n    background-color: #022B2A;\n    border: 1px solid #022B2A;\n    color: #fff;\n    padding: 10px 16px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    border-radius: 6px;\n}\n\n\n// End button styles\n\nmain.light-style__page-container{\n\n    padding: 20px 40px;\n    max-width: 1080px;\n\n    \n    h5, .h5 {\n        font-size: 1.625rem;\n    }\n    \n    .page-header {\n        margin: 0;\n    }\n    \n    section {\n        margin-bottom: 30px;\n    }\n\n    .section-discription {\n        font-size: 1em;\n        color: lightslategray;\n        margin-bottom: 20px;\n    }\n}\n\n.light-style__modal-container{\n    > * {\n        padding: 1rem 2rem;\n    }\n\n    h5, .h5 {\n        font-size: 1.625rem;\n    }\n\n    h6 {\n        color: #022B2A;\n        font-weight: bold;\n    }\n\n    .modal-header {\n        display: flex;\n        flex-direction: column;\n        align-items: normal;\n        border-bottom: 1px solid #E5E5E5;\n    }\n\n    .page-header {\n        margin: 0;\n    }\n    \n    section {\n        margin-bottom: 30px;\n    }\n\n    .section-discription {\n        font-size: 1em;\n        color: lightslategray;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
